import { useGLTF, useAnimations } from '@react-three/drei';
import { useLoader, useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import { ObjectLoader, LoopOnce } from 'three';
import { d as defineSrc } from './index-CAxCDj_E.esm.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import 'clsx';
import './common-DBpCdW70.esm.js';

const Lock = () => {
  const ref = useRef();
  const model = useGLTF(defineSrc('lock.glb'));
  const lights = useLoader(ObjectLoader, defineSrc('lock-light.json'));
  model.scene.traverse(node => {
    if (node.isMesh) {
      node.castShadow = true;
      node.receiveShadow = true;
    }
  });
  const {
    clips,
    mixer
  } = useAnimations(model.animations, ref);
  let frame = 0;
  useFrame(() => {
    mixer.clipAction(clips[0]).play().setLoop(LoopOnce, 1);
    model.scene.position.y = Math.sin(frame++ * 0.04) * 0.2;
    model.materials.Standard.map.offset.x += -1e-3;
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("primitive", {
      ref: ref,
      scale: 1.4,
      object: model.scene
    }), /*#__PURE__*/jsx("primitive", {
      object: lights
    })]
  });
};

export { Lock as default };
//# sourceMappingURL=Lock-DQdry3N8.esm.js.map
